module.exports = __webpack_public_path__ + "static/jamie-montemayor.c5972ab4.webp";